<template>
  <a
    :href="client_download_url"
    download="chat_installer.exe"
    v-if="client_download_url"
    class="cpt-client-download-a"
    @click="handleDownloadClient"
  >
    <div class="client-download">
      <i class="iconfont icon-top-bold"></i>
      <span>下载客户端</span>
    </div>
  </a>
</template>

<script>
import { mapGetters } from 'vuex'
import { reportData } from '_api/report'
export default {
  computed: {
    ...mapGetters(['client_download_url']),
  },
  methods: {
    handleDownloadClient() {
      reportData('client_download')
    },
  },
}
</script>

<style lang="scss">
.cpt-client-download-a{
  .client-download {
    display: block;
    color: $d-op-4;
    width: 86px;
    height: 30px;
    float: right;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      background: $d-op-2;
    }

    i {
      width: 10px;
      height: 10px;
      margin-right: 2px;
      flex-shrink: 0;
      transform: rotate(180deg);

      &::before {
        width: 20px;
        height: 20px;
        font-size: 20px;
        transform: scale(.5);
        transform-origin: left top;
      }
    }

    span {
      font-weight: 400;
      font-size: 22px;
      line-height: 32px;
      text-align: center;
      letter-spacing: 0.01em;
      width: 56px;
      height: 16px;
      padding-bottom: 2px;
      transform: scale(.5);
      white-space: nowrap;
      transform-origin: left top;
    }
  }
}

</style>